import { createReducer } from "redux-starter-kit";

const initialState = {
  isAuthenticated: false,
  accessToken: null,
  idToken: null,
  email: null,
  name: null,
  avatar: null,
  referenceId: null,
  roles: [],
  exp: null
};

const authReducer = createReducer(initialState, {
  SIGNIN_SUCCESS: (state, action) => {
    const tokens = action.payload?.tokens;
    if (!tokens) return state;
    return {
      isAuthenticated: true,
      accessToken: tokens.accessToken.toString(),
      idToken: tokens.idToken.toString(),
      email: tokens.idToken.payload.email,
      name: tokens.idToken.payload.name,
      roles: tokens.accessToken.payload['cognito:groups'] || [],
      exp: tokens.accessToken.payload.exp
    };
  },
  SIGNOUT_SUCCESS: (state, action) => initialState
});

export default authReducer;
